import React from 'react';
import { twMerge } from 'tailwind-merge';
type Variant = 'primary' | 'outline' | 'ghost';
type Size = 'sm' | 'md';
type CtaButtonProps = {
  href: string;
  children: React.ReactNode;
  variant?: Variant;
  size?: Size;
  /** Analytics hook: added as a class name and a data-track attribute. */
  track: string;
  className?: string;
  'aria-label'?: string;
};
const base = 'inline-flex items-center justify-center gap-2 rounded-full font-semibold tracking-wide whitespace-nowrap transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-aqua-400 focus-visible:ring-offset-2 active:scale-[0.98]';
const variants: Record<Variant, string> = {
  primary: 'bg-aqua-400 text-night-900 hover:bg-aqua-300 shadow-glow',
  outline: 'border border-aqua-400/60 text-aqua-300 hover:bg-aqua-400/10 hover:border-aqua-300',
  ghost: 'border border-night-900/15 bg-white text-night-900 hover:border-aqua-400 hover:text-aqua-600'
};
const sizes: Record<Size, string> = {
  sm: 'h-9 px-4 text-[13px]',
  md: 'h-11 px-5 text-sm'
};
export function CtaButton({
  href,
  children,
  variant = 'primary',
  size = 'md',
  track,
  className,
  ...rest
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} data-track={track} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={twMerge(base, variants[variant], sizes[size], track, className)} {...rest} data-id="element-140" data-mp="2qff0o8ve8e62">
      {children}
    </a>;
}